import { tz } from "../date-time/timezone";

const defaultTimeZone = tz.EuropeStockholm;

export { defaultTimeZone };
